import React from 'react';
import { FullPrayerHub } from '@api/routes/prayer-hubs/get/params';

import css from './prayer-section.module.scss';

interface Props {
  prayerContainerRef: React.RefObject<HTMLDivElement>;
  prayerTitleRef: React.RefObject<HTMLDivElement>;
  prayerContentRef: React.RefObject<HTMLDivElement>;
  prayerInfoRef: React.RefObject<HTMLDivElement>;
  psalmsChapter?: FullPrayerHub['psalmsChapter'] | null;
}

export const PrayerSection: React.FC<Props> = ({
  prayerContainerRef,
  prayerTitleRef,
  prayerContentRef,
  prayerInfoRef,
  psalmsChapter,
}) => {
  return (
    <div ref={prayerContainerRef} className={css.prayer}>
      <div ref={prayerTitleRef} className={css.title}>
        זה הזמן שלך להתחבר, תאמר בכוונה:
      </div>
      <div ref={prayerContentRef} className={css.content}>
        {psalmsChapter?.text.he ?? ''}
      </div>
      <div ref={prayerInfoRef} className={css.info}>
        {psalmsChapter?.note.he ?? ''}
      </div>
    </div>
  );
};
